import { Service } from "typedi";
import { DesktopSnapshotDTO } from "../../../../../schools-backend/src/student/application/dtos/DesktopSnapshot";
import { AgentRPCCommand } from "../../../../shared/RPC/AgentRPCCommand";
import { AgentRPCCommands } from "../../../../shared/RPC/AgentRPCCommands";
import { DesktopSnapshotAggregator } from "../snapshot/DesktopSnapshotAggregator";

@Service()
export class GetDesktopSnapshot implements AgentRPCCommand<"get.desktop.snapshot"> {
    constructor(
        agentRPCCommands: AgentRPCCommands,
        private readonly aggregator: DesktopSnapshotAggregator
    ) {
        agentRPCCommands.register("get.desktop.snapshot", this);
    }

    async run(): Promise<DesktopSnapshotDTO> {
        return this.aggregator.collect();
    }
}
